import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Button, DatePicker, Form, Input, message, Select, Table, Tooltip, Upload } from 'antd'
import { FaPlus, FaEdit, FaEye, FaUpload, FaCheck } from 'react-icons/fa'
import { RiDeleteBin6Line } from 'react-icons/ri'
import CustomModal from '../../Components/CustomModal/CustomModal'
import { CustomSelect, Datepicker, DeleteModal, GtfsUpload, Inputs, SearchOrganizations, SearchUser, TableSkeleton, VehicleMap } from '../../Components'
import { GET, POST } from '../../utils/apis'
import { setTotalVehicles, setVechiclesData, setFilterVechiclesData, setTotalFilteredVehicles, setVehiclePercentage } from '../../Redux/actions/vehiclesAction'
import { fetchOrganization, fetchUsers, fetchVehicles, formatDate, verifyToken, getBase64, fetchAllOrganization } from '../../utils/helpers'
import { secureApi } from '../../Config/api'
import { allPaths, dateFormate, translations, imageTypes, pageSizeOptions } from '../../utils/constants'
import { DatabaseZap, Search, Building2, Users, ArrowDownToLine, ArrowUpDown, ExternalLink } from "lucide-react"
import { routeForecastUrl } from '../../utils/routeForecastLink'
import { setOrganizationsData, setOrganizationFilter } from '../../Redux/actions/organizationActions'
import moment from 'moment'
import { setUserData } from '../../Redux/actions/userAction'
import { UploadOutlined } from '@ant-design/icons'
import { setUsersAdminFilter } from '../../Redux/actions/usersAdminFilterActions'
import { setVehiclePageNumber } from '../../Redux/actions/filterVehiclesAction'
import axios from 'axios'

const Vehicles = ({ language }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const user = useSelector(state => state?.authReducer?.user)
  let authUser = user
  const userId = user?.id
  const [addVehicles] = Form.useForm()
  const [editVehicles] = Form.useForm()
  const [uploadForm] = Form.useForm()
  const vehicleFromRedux = useSelector((state) => state.vehiclesReducer?.vehicles)
  const filterVehicleFromRedux = useSelector((state) => state.vehiclesReducer?.filterVehicles)
  const totalFilteredVehicles = useSelector(state => state.vehiclesReducer?.totalFilteredVehicles)
  const organizationDetails = useSelector(state => state?.authReducer?.organization)
  const organizationFilter = useSelector(state => state.organizationReducer?.organizationFilter)
  const vehicles = useSelector(state => state.vehiclesReducer?.vehicles)
  const organizationFromRedux = useSelector((state) => state.organizationReducer?.allOrganizations)
  const currentPage = useSelector(state => state.filterVehicleReducer?.pageNumber || 1)
  const organizationCount = useSelector(state => state.organizationReducer?.orgSelectionCount || 0)
  const userCount = useSelector(state => state.userReducer?.userSelectionCount || 0)
  const usersAdminFilter = useSelector(state => state.usersAdminFilterReducer?.usersAdminFilter)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [viewModal, setViewModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [itemToDelete, setItemToDelete] = useState(null)
  const [searchModal, setSearchModal] = useState(false)
  const [searchUserModal, setSearchUserModal] = useState(false)
  const [addDataLoading, setAddDataLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [initialLoading, setInitialLoading] = useState(false)
  // First page fetch shows a skeleton instead of the empty state; later
  // fetches (search, filters, paging) keep the table and overlay a spinner.
  const [tableLoading, setTableLoading] = useState(true)
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false)
  const [editDataLoading, setEditDataLoading] = useState(false)
  const [toEdit, setToEdit] = useState(null)
  const [organizationId, setOrganizationId] = useState(organizationDetails?.id)
  const [organizations, setOrganizations] = useState([])
  const [selectedOrganizations, setSelectedOrganizations] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [sortOrder, setSortOrder] = useState('') // '' = default order, 'asc' | 'desc'
  // Devices column header: '' | 'asc' | 'desc' by device count (server-side,
  // whole fleet). Independent of the toolbar select, which sorts by created_at;
  // when both are set the count orders first and the date breaks ties.
  const [deviceSort, setDeviceSort] = useState('')
  const [users, setUsers] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([])
  const [logoFile, setLogoFile] = useState(null)
  const [logoUrl, setLogoUrl] = useState(null)
  const [pageSize, setPageSize] = useState(10)
  const [totalItems, setTotalItems] = useState(0)
  const [uploadModal, setUploadModal] = useState(false)
  const [gtfsModal, setGtfsModal] = useState(false)
  const [selectedOrgForUpload, setSelectedOrgForUpload] = useState(null)
  const [excelFile, setExcelFile] = useState(null)
  const [uploadLoading, setUploadLoading] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  useEffect(() => {
    if (organizationFilter) {
      fetchVehicles({ setTotalVehicles, setVehiclePercentage, setVechiclesData, dispatch, user, organizationId: organizationFilter })
    }
  }, [organizationFilter])

  useEffect(() => {
    verifyToken(history, dispatch)
    fetchUsers({ setLoading, setUsers, dispatch, setUserData, authUser, organizationId })
    fetchAllOrganization({ dispatch })
    setOrganizations(organizationFromRedux)
    fetchVehicles({ setTotalVehicles, setVehiclePercentage, setVechiclesData, dispatch, user, organizationId: organizationDetails?.id })
    fetchFilteredVehicle()
  }, [])

  useEffect(() => {
    if (filterVehicleFromRedux?.length === 0) {
      setInitialLoading(true)

      const timeout = setTimeout(() => {
        setInitialLoading(false)
      }, 200)

      return () => clearTimeout(timeout)
    } else {
      setInitialLoading(false)
    }
  }, [filterVehicleFromRedux])

  useEffect(() => {
    fetchFilteredVehicle()
  }, [organizationFilter, searchQuery, usersAdminFilter, currentPage, pageSize, sortOrder, deviceSort])

  const handleSearch = (query) => {
    setSearchQuery(query)
  }

  const disabledDate = (current) => {
    return current && current > moment().endOf('day')
  }

  const handleOrganizationChange = (value) => {
    dispatch(setOrganizationFilter(value))
    fetchVehicles({ setTotalVehicles, setVehiclePercentage, setVechiclesData, dispatch, user, organizationId: value })
  }

  const handleUserChange = (value) => {
    dispatch(setUsersAdminFilter(value))
    setSelectedUsers(value)
  }

  const fetchFilteredVehicle = async () => {
    setTableLoading(true)
    try {
      const params = {
        user_id: user?.id,
        ...(user?.role === 'superAdmin'
          ? { organization_id: organizationFilter }
          : { selectUSerId: usersAdminFilter }),
        resourceType: 'vehicles',
        searchQuery: searchQuery,
        ...(sortOrder ? { sortBy: 'created_at', sortOrder } : {}),
        ...(deviceSort ? { deviceSort } : {}),
        page: currentPage,
        limit: pageSize
      }
      const response = await secureApi?.get(GET?.GET_ORGANIZATION_FILTER, { params })
      if (response?.success) {
        dispatch(setFilterVechiclesData(response?.data))
        dispatch(setTotalFilteredVehicles(response?.total || 0))
        setTotalItems(response?.total || 0)
      } else {
        message.error(response?.message || 'Failed to fetch vehicles.')
      }
    } catch (error) {
      message.error('Error fetching filtered vehicles.')
    } finally {
      setTableLoading(false)
      setHasLoadedOnce(true)
    }
  }

  const showModal = async () => {
    setIsModalVisible(true)
  }

  const viewDetails = (record) => {
    history.push({
      pathname: `${allPaths?.VEHICLESDETAILS}/${record?.id}`,
      state: { vehicle: record },
    })
  }

  const getFileList = () => {
    if (logoUrl) {
      return [
        {
          uid: '-1',
          name: 'logo.png',
          status: 'done',
          url: logoUrl,
        },
      ];
    }
    return [];
  };

  const handleUpload = (file) => {
    setLogoUrl(null)
    getBase64(file)
      .then((base64) => {
        setLogoFile(file)
        setLogoUrl(base64)
      })
    return false
  }

  const handleAction = async () => {
    const isTokenValid = await verifyToken(history, dispatch)

    if (!isTokenValid) {
      message.error('Session expired. Please log in again.')
      return
    }
    setAddDataLoading(true)

    try {
      const values = addVehicles.getFieldsValue()

      if (!values?.licensePlate || !values?.operationStartDate || !values?.vehicleModel || !values?.vehicleCategory || !values?.yearOfManufacture) {
        message.error(translations[language]?.allFieldsRequired)
        setAddDataLoading(false)
        return
      }

      const operationStartDate = values?.operationStartDate?.format('YYYY-MM-DD')
      const yearOfManufacture = values?.yearOfManufacture?.format('YYYY-MM-DD')

      const organizationIdToSend = user?.role === 'superAdmin' ? values?.organization : organizationDetails?.id

      if (!organizationIdToSend) {
        message.error(translations[language]?.organizationRequired)
        setAddDataLoading(false)
        return
      }

      let logoUrl = null

      if (logoFile) {
        const formData = new FormData()
        formData.append('files', logoFile)

        const uploadRes = await secureApi?.post(POST?.UPLOAD_VEHICLE_LOGO, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        logoUrl = uploadRes?.fileUrls?.[0] || null
      }

      const payload = {
        userId,
        vehicleName: values?.vehicleName,
        licensePlate: values?.licensePlate,
        vehicleModel: values?.vehicleModel,
        operationStartDate,
        yearOfManufacture,
        vehicleCategory: values?.vehicleCategory,
        techMaintenanceNotes: values?.companyAffiliation || '',
        registeringNumber: values?.registeringNumber,
        organizationId: organizationIdToSend,
        logo_url: logoUrl,
      }

      const res = await secureApi?.post(POST?.ADD_VEHICLE, payload)
      // console.log(res, 'res')
      if (res?.success) {
        fetchVehicles({ setTotalVehicles, setVehiclePercentage, setVechiclesData, dispatch, user, organizationId })
        fetchAllOrganization({ dispatch })
        message.success(translations[language]?.vehicleAdded)
        addVehicles.resetFields()
        setLogoFile(null)
        setLogoUrl(null)
        setIsModalVisible(false)
        fetchFilteredVehicle()
      }
      else if (res?.success === false) {
        message.error(res?.error || res?.message)
      }
    } catch (err) {
      message.error(err?.response?.error || 'Unexpected error occurred.')
    } finally {
      setAddDataLoading(false)
    }
  }

  const handleEdit = async (record) => {
    const isTokenValid = await verifyToken(history, dispatch)

    if (!isTokenValid) {
      message.error('Session expired. Please log in again.')
      return
    }

    const isOwner = record?.user_id === userId
    const isAdmin = user?.role === 'admin'
    const isSuperAdmin = user?.role === 'superAdmin'

    if (!isOwner && !isAdmin && !isSuperAdmin) {
      message.error(translations[language]?.unauthorizedEdit)
      return
    }
    setEditModal(true)
    setViewModal(false)
    setToEdit(record)
    setLogoFile(null)
    setLogoUrl(null)
    const operationStartDate = record?.operation_start_date ? moment(record?.operation_start_date) : null
    const yearOfManufacture = record?.year_of_manufacture ? moment(record?.year_of_manufacture) : null

    editVehicles.setFieldsValue({
      vehicleName: record?.vehicle_name,
      licensePlate: record?.license_plate,
      operationStartDate: operationStartDate,
      techMaintenanceNotes: record?.tech_maintenance_notes === "undefined" ? "" : record?.tech_maintenance_notes,
      vehicleCategory: record?.vehicle_category,
      vehicleModel: record?.vehicle_model,
      yearOfManufacture: yearOfManufacture,
      organization: record?.organization_id,
      registeringNumber: record?.registering_number
    })
    setLogoUrl(record?.logo)
  }

  const handleUpdateVehicle = async () => {

    setEditDataLoading(true)

    try {
      const isTokenValid = await verifyToken(history, dispatch)
      if (!isTokenValid) {
        message.error('Session expired. Please log in again.')
        return
      }

      const values = editVehicles.getFieldsValue()

      // Format dates properly
      const operationStartDate = values?.operationStartDate?.format('YYYY-MM-DD') || null
      const yearOfManufacture = values?.yearOfManufacture?.format('YYYY-MM-DD') || null

      // Prepare logo URL
      let logoUrls = toEdit?.logo || null

      if (logoFile && logoFile !== toEdit?.logo) {
        const formData = new FormData()
        formData.append('files', logoFile)

        const uploadResponse = await secureApi?.post(POST?.UPLOAD_VEHICLE_LOGO, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        logoUrls = uploadResponse?.fileUrls?.[0] || null

        if (!logoUrls) {
          message.error('Failed to upload logo.')
          setEditDataLoading(false)
          return
        }
      }

      // Prepare payload for update
      const payload = {
        id: toEdit?.id,
        vehicleName: values?.vehicleName,
        licensePlate: values?.licensePlate,
        operationStartDate,
        vehicleCategory: values?.vehicleCategory,
        vehicleModel: values?.vehicleModel,
        yearOfManufacture,
        registeringNumber: values?.registeringNumber,
        logo: logoUrls,
        organizationId: toEdit?.organization_id,
      }

      const response = await secureApi.post(POST?.UPDATE_VEHICLE, payload)
      if (response?.success === true) {
        message.success(translations[language]?.vehicleUpdated)
        setLogoFile(null)
        setLogoUrl(null)
        setEditModal(false)
        editVehicles.resetFields()
        fetchFilteredVehicle()
      }
      else if (response?.success === false) {
        message.error(response?.error || response?.message)
      }
    } catch (error) {
      console.error(error)
      message.error(error?.response?.data?.message || 'Error updating vehicle.')
    } finally {
      setEditDataLoading(false)
    }
  }

  const openEditModal = () => {
    setViewModal(false)
    setEditModal(true)
    setLogoFile(null)
  }

  const handleDelete = async (record) => {
    const isTokenValid = await verifyToken(history, dispatch);
    if (!isTokenValid) {
      message.error('Session expired. Please log in again.');
      return;
    }
    setDeleteModal(true)
    setItemToDelete(record)
  }

  const handleClose = () => {
    setIsModalVisible(false)
    addVehicles.resetFields()
    setLogoFile(null)
    setLogoUrl(null)
  }

  const closeDetails = () => {
    setSelectedRecord(null)
    setViewModal(false)
  }

  const closeEditModal = () => {
    editVehicles.resetFields()
    setEditModal(false)
  }

  const handleCancel = () => {
    setDeleteModal(false)
    setItemToDelete(null)
  }

  const handleConfirmDelete = async () => {
    const isTokenValid = await verifyToken(history, dispatch)

    if (!isTokenValid) {
      message.error('Session expired. Please log in again.')
      return
    }

    setDeleteModal(false)
    setLoading(true)

    if (itemToDelete) {
      try {
        const response = await secureApi.post(POST?.DELETE_VEHICLE, {
          id: itemToDelete?.id,
          userId: userId
        })
        // console.log(response, 'response')
        if (response?.success === true) {
          message.success(translations[language]?.vehicleDeleted)
          const updatedvehicles = vehicles?.filter(vehicles => vehicles?.id !== itemToDelete?.id)
          dispatch(setVechiclesData(updatedvehicles))
          dispatch(setTotalVehicles(updatedvehicles?.length))
          fetchFilteredVehicle()
          fetchVehicles({ setTotalVehicles, setVechiclesData, dispatch, user, organizationId })
          fetchAllOrganization({ dispatch })
        }
        else if (response?.success === false) {
          message.error(response?.error || response?.message)
        }
      } catch (error) {
        console.error(" Error Deleting Vehicle:", error)
        message.error(error.response?.message || 'Failed to delete vehicle. Please try again.')
      }
      setLoading(false)
    }

    setItemToDelete(null)
  }

  const columns = [
    {
      title: translations[language]?.vehicleName,
      dataIndex: 'vehicle_name',
      key: 'vehicleName',
      render: (text, record) => {
        return (
          <div onClick={(e) => { e.stopPropagation(); viewDetails(record) }} className='vl-name-cell' title={text}>
            <span className='vl-avatar'>{vehicleInitials(text)}</span>
            <span className='vl-name-text capitalized-name'>{text || '-'}</span>
            {Number(record?.router_count) > 0 && (
              <Tooltip title={record?.router_online ? translations[language]?.routerOnline : translations[language]?.routerOffline}>
                <span className={`vl-online-dot ${record?.router_online ? 'on' : 'off'}`} />
              </Tooltip>
            )}
            <FaEye className='vl-name-view' />
            {record?.forecast_device ? (
              <Tooltip title={translations[language]?.openRouteForecast}>
                <a
                  className='vl-name-forecast'
                  href={routeForecastUrl(record.forecast_device)}
                  target='_blank'
                  rel='noopener noreferrer'
                  onClick={(e) => e.stopPropagation()}
                  aria-label={translations[language]?.routeForecastLink}
                >
                  <ExternalLink size={14} />
                </a>
              </Tooltip>
            ) : null}
          </div>
        )
      }
    },
    {
      title: translations[language]?.licensePlate,
      dataIndex: 'license_plate',
      key: 'licensePlate',
      render: (text) => (text ? <span className='vl-plate'>{text}</span> : <span className='vl-muted'>-</span>),
    },
    {
      title: translations[language]?.registeringNumber,
      dataIndex: 'registering_number',
      key: 'registeringNumber',
      render: (text) => (text ? <span>{text}</span> : <span className='vl-muted'>-</span>),
    },
    // {
    //   title: translations[language]?.vehicleCategory,
    //   dataIndex: 'vehicle_category',
    //   key: 'vehicleCategory'
    // },
    {
      title: translations[language]?.vehicleModel,
      dataIndex: 'vehicle_model',
      key: 'vehicleModel',
      render: (text) => (text ? <span className='capitalized-name'>{text}</span> : <span className='vl-muted'>-</span>),
    },
    {
      title: translations[language]?.yearOfManufacture,
      dataIndex: 'year_of_manufacture',
      key: 'yearOfManufacture',
      render: (text) => {
        if (!text) {
          return <span>-</span>
        }
        const date = new Date(text)
        const year = isNaN(date.getTime()) ? '-' : date.getFullYear()
        return <span>{year}</span>
      }
    },
    {
      title: translations[language]?.operationStartDate,
      dataIndex: 'operation_start_date',
      key: 'operationStartDate',
      render: (text) => <span>{formatDate(text)}</span>,
    },
    {
      title: translations[language]?.totalDevices,
      dataIndex: 'device_count',
      key: 'Total Devices',
      align: 'center',
      sorter: true,
      sortOrder: deviceSort ? (deviceSort === 'asc' ? 'ascend' : 'descend') : null,
      render: (value) => (
        <span className={`vl-count-chip${!Number(value) ? ' vl-count-chip-zero' : ''}`}>{value ?? 0}</span>
      ),
    },
    {
      title: translations[language]?.gtfs,
      dataIndex: 'gtfs_feed_name',
      key: 'gtfsFeed',
      render: (text, record) => {
        if (!record?.gtfs_feed_source) {
          return <span className='vl-muted'>-</span>
        }
        // The GTFS pages are admin-only; other roles just see the name.
        const canOpen = ['admin', 'superAdmin'].includes(user?.role)
        return (
          <Tooltip title={canOpen ? translations[language]?.gtfsDetails : null}>
            <span
              className={`vl-gtfs-chip${canOpen ? ' vl-gtfs-chip-link' : ''}`}
              onClick={canOpen ? (e) => {
                e.stopPropagation()
                history.push({
                  pathname: `${allPaths?.GTFS_DETAILS}/${encodeURIComponent(record?.gtfs_feed_source)}`,
                  state: { feedName: text },
                })
              } : undefined}
            >
              {text || record?.gtfs_feed_source}
            </span>
          </Tooltip>
        )
      },
    },
    ...(user?.role === 'superAdmin' ? [
      {
        title: translations[language]?.organizations,
        dataIndex: 'organization_name',
        key: 'organization_name',
        render: (text) => (
          <span className='capitalized-name'>{text}</span>
        ),
      }
    ] : []),
    ...(user?.role === 'admin' ? [
      {
        title: translations[language]?.createdBy,
        dataIndex: 'created_by',
        key: 'createdBy',
        render: (text, record) => (
          <Tooltip title={record.created_by_email}>
            <span>{text}</span>
          </Tooltip>
        ),
      }
    ] : []),
    {
      title: translations[language]?.action,
      key: 'action',
      width: 100,
      render: (_, record) => (
        <div className='vl-actions' onClick={(e) => e.stopPropagation()}>
          <Tooltip title={translations[language]?.viewDetails || translations[language]?.details}>
            <button type='button' className='vl-action-btn vl-action-view' onClick={() => viewDetails(record)}>
              <FaEye size={14} />
            </button>
          </Tooltip>
          <Tooltip title={translations[language]?.edit}>
            <button type='button' className='vl-action-btn vl-action-edit' onClick={() => handleEdit(record)}>
              <FaEdit size={14} />
            </button>
          </Tooltip>
          <Tooltip title={translations[language]?.delete}>
            <button type='button' className='vl-action-btn vl-action-delete' onClick={() => handleDelete(record)}>
              <RiDeleteBin6Line size={15} />
            </button>
          </Tooltip>
        </div>
      )
    },
  ]

  // Two-letter avatar for the name cell (first letters of the first two words).
  const vehicleInitials = (name) =>
    String(name || '')
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((w) => w[0])
      .join('')
      .toUpperCase() || '-'

  const showSearchModal = () => {
    // The per-organization totals in the panel come from the organizations
    // list fetched at mount; refresh them on open so vehicles added or
    // imported since (Excel upload) are counted.
    if (!searchModal) fetchAllOrganization({ dispatch })
    setSearchModal(!searchModal)
  }

  const showSearchUserModal = () => {
    setSearchUserModal(!searchUserModal)
  }

  const handleExcelUpload = async () => {
    try {
      const formValues = await uploadForm.validateFields()

      if (!excelFile) {
        message.error('Please select an Excel file')
        return
      }

      const orgIdToSend =
        user?.role === 'superAdmin'
          ? selectedOrgForUpload
          : organizationDetails?.id

      if (!user?.id) {
        message.error('User ID missing — please re-login.')
        return
      }

      if (!orgIdToSend) {
        message.error('Organization ID missing — please select or re-login.')
        return
      }

      // console.log(formValues, 'formValues')
      setUploadLoading(true)

      const formData = new FormData()
      formData.append('file', excelFile)
      formData.append('userId', user?.id)
      formData.append('organizationId', orgIdToSend)
      formData.append('operationStartDate', formValues.operationStartDate.format('YYYY-MM-DD'))
      formData.append('yearOfManufacture', formValues.yearOfManufacture.format('YYYY-MM-DD'))

      const res = await secureApi.post(POST?.ADD_VEHICLE_DATA, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })

      if (res?.success) {
        message.success(res?.message || 'File uploaded successfully!')
        fetchFilteredVehicle()
        fetchVehicles({ setTotalVehicles, setVechiclesData, dispatch, user, organizationId })
        fetchAllOrganization({ dispatch })
        setUploadModal(false)
        setExcelFile(null)
        setSelectedOrgForUpload(null)
        uploadForm.resetFields()
      } else {
        message.error(res?.message || 'Upload failed.')
      }
    } catch (err) {
      message.error(err?.response?.data?.message || 'Error while uploading file.')
    } finally {
      setUploadLoading(false)
    }
  }

  const downloadVehiclePDF = async () => {
    try {
      const isTokenValid = await verifyToken(history, dispatch)
      if (!isTokenValid) {
        message.error('Session expired. Please log in again.')
        return
      }

      setDownloadLoading(true)

      const params = {
        user_id: user?.id,
        role: user?.role,
        searchQuery: searchQuery,
        organizationId: user?.organization_id || organizationDetails?.id,
        language,
        ...(user?.role === 'superAdmin'
          ? { organization_id: organizationFilter }
          : { selectUSerId: usersAdminFilter }),
      }

      const res = await axios.get(GET?.DOWNLOAD_VEHICLE_PDF, { params })

      if (res?.data?.success && res?.data?.data) {
        const pdfUrl = res.data.data

        const link = document.createElement('a')
        link.href = pdfUrl
        link.download = `${language === 'it' ? 'Rapporto_Veicoli' : 'Vehicle_Report'}.pdf`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        message.success(
          language === 'it'
            ? 'Rapporto veicoli scaricato con successo'
            : 'Vehicle report downloaded successfully'
        )
      } else {
        message.error(
          res?.data?.message ||
          (language === 'it'
            ? 'Impossibile scaricare il rapporto'
            : 'Failed to download report')
        )
      }
    } catch (error) {
      console.error('PDF download error:', error)
      message.error('Error downloading vehicle report')
    } finally {
      setDownloadLoading(false)
    }
  }

  return (
    <div className='main-container'>
      <div className='main-inner-container'>
        <div className='insider-container-buttons report-header-div'>

          <h1 className='main-heading'>{translations[language]?.vehicles}</h1>

        </div>
        <div className='insider-container'>
          {vehicleFromRedux?.length === 0 ? (null) : <div className='insider-container-buttons vl-toolbar'>
            <div className='vehicle-buttons-div vl-toolbar-actions'>
              <button type='button' className='add-button' onClick={showModal}>
                <FaPlus className='icons' />
                {translations[language]?.addVehicle}
              </button>

              <button
                className='add-button upload-vehicle-button'
                onClick={() => setUploadModal(true)}
              >
                <FaUpload className='icons' />
                {translations[language]?.uploadVehicle}
              </button>

              {['admin', 'superAdmin'].includes(user?.role) && (
                <button
                  className='add-button upload-vehicle-button'
                  onClick={() => setGtfsModal(true)}
                >
                  <FaUpload className='icons' />
                  {language === 'it' ? 'Carica GTFS' : 'Upload GTFS'}
                </button>
              )}
            </div>
            <div className='search-main-div vl-toolbar-filters'>
              <div className="search-inner-div">
                <Search className="search-icon" />
                <input
                  placeholder={translations[language]?.searchVehicles}
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="search-input"
                />
                {searchQuery && (
                  <span className="clear-icon" style={{ cursor: "pointer" }} onClick={() => handleSearch("")}>
                    ✕
                  </span>
                )}
              </div>
              <div className={`sort-select-wrap ${sortOrder ? 'sort-select-active' : ''}`}>
                <ArrowUpDown className='sort-select-icon' />
                <Select
                  className='sort-select'
                  dropdownClassName='custom-select-dropdown sort-select-dropdown'
                  placeholder={translations[language]?.sortByCreated}
                  value={sortOrder || undefined}
                  onChange={(value) => {
                    setSortOrder(value || '')
                    dispatch(setVehiclePageNumber(1))
                  }}
                  bordered={false}
                  allowClear
                  options={[
                    { value: 'desc', label: translations[language]?.newestFirst },
                    { value: 'asc', label: translations[language]?.oldestFirst },
                  ]}
                />
              </div>
              {user?.role === 'superAdmin' ? <div className='get-reports-container'>
                <button
                  className={`add-button organization ${searchModal ? 'open-organization' : 'close-organization'}`}
                  onClick={showSearchModal}
                >
                  <Building2 />
                  {translations[language]?.organizations}
                  {organizationCount ? <div className="filter-count-badge">
                    {organizationCount}
                  </div> : null}
                </button>
              </div> : null}
              {user?.role === 'admin' ? <div className='get-reports-container'>
                <button
                  className={`add-button organization ${searchUserModal ? 'open-organization' : 'close-organization'}`}
                  onClick={showSearchUserModal}
                >
                  <Users />
                  {translations[language]?.users}
                  {userCount ?
                    <div className="filter-count-badge">
                      {userCount}
                    </div>
                    : null
                  }
                </button>
              </div> : null}
            </div>
          </div>}
          <div className='table-container'>
            <div className='table-inner-container'>
              {/* The last fetched page is persisted in redux, so on a revisit it
                  renders at once (with the table's spinner while it refreshes);
                  the skeleton is only for a genuinely cold first load. */}
              {!hasLoadedOnce && !(filterVehicleFromRedux?.length > 0) ? <TableSkeleton rows={pageSize > 10 ? 10 : pageSize} columns={user?.role === 'superAdmin' ? 10 : 9} /> : vehicleFromRedux?.length === 0 ? <div className="no-vehicles-container">
                <div className="no-vehicles-text-center">
                  <div className="flex-col-center">
                    <div className="no-vehicles-text-center">
                      <DatabaseZap className='no-vehicle-icon' />
                      <h3 className="no-vehicles-heading">{translations[language]?.noVehiclesFound}</h3>
                      <p className="no-vehicles-description">
                        {translations[language]?.addVehicleToSee}
                      </p>
                      <div className='vehicle-buttons-div'>
                        <buttons className='add-button' onClick={showModal}
                        >
                          <FaPlus className='icons' />
                          {translations[language]?.addVehicle}
                        </buttons>
                        {/* GTFS upload must stay reachable with an empty fleet —
                            the org's schedule is uploaded before its vehicles
                            are created/attached. */}
                        {['admin', 'superAdmin'].includes(user?.role) && (
                          <button
                            className='add-button upload-vehicle-button'
                            onClick={() => setGtfsModal(true)}
                          >
                            <FaUpload className='icons' />
                            {language === 'it' ? 'Carica GTFS' : 'Upload GTFS'}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div> : <>

                <div className='table-header vl-list-header'>
                  <div className='vl-list-title'>
                    <h1 className='h1-theme-color vehicle-list-heading margin-bottom-0'>{translations[language]?.vehiclesList}</h1>
                    <span className='vl-total-chip'>
                      {translations[language]?.totalRecord}: <strong>{totalFilteredVehicles ?? 0}</strong>
                    </span>
                  </div>
                  <Button
                    loading={downloadLoading}
                    type='primary'
                    className='add-button'
                    onClick={downloadVehiclePDF}
                  >
                    {translations[language]?.getPDF}
                    <ArrowDownToLine style={{ height: '18px' }} className='icons' />
                  </Button>
                </div>

                <Table
                  className='vl-table vl-table-clickable'
                  rowKey={(r) => r?.id || r?.license_plate}
                  dataSource={filterVehicleFromRedux}
                  columns={columns}
                  onRow={(record) => ({ onClick: () => viewDetails(record) })}
                  onChange={(_pagination, _filters, sorter, extra) => {
                    if (extra?.action !== 'sort') return
                    if (sorter?.columnKey === 'Total Devices') {
                      setDeviceSort(sorter?.order === 'ascend' ? 'asc' : sorter?.order === 'descend' ? 'desc' : '')
                      dispatch(setVehiclePageNumber(1))
                    }
                  }}

                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    total: totalItems,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) =>
                      (translations[language]?.showingRange || 'Showing {from}-{to} of {total}')
                        .replace('{from}', range[0])
                        .replace('{to}', range[1])
                        .replace('{total}', total),
                    pageSizeOptions,
                    onShowSizeChange: (current, size) => {
                      setPageSize(size)
                      dispatch(setVehiclePageNumber(1)) // Reset to page 1
                    },
                    onChange: (page, pageSize) => {
                      dispatch(setVehiclePageNumber(page))
                      setPageSize(pageSize)
                    }
                  }}
                  scroll={{ x: 'max-content' }}
                  loading={initialLoading || tableLoading}
                />

              </>}
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        isVisible={isModalVisible}
        onClose={handleClose}
        title={translations[language]?.addVehicle}
        actionText={translations[language]?.addVehicle}
        onAction={handleAction}
        loading={addDataLoading}
        language={language}
      >
        <Form form={addVehicles} layout='vertical'>
          <div className='flex-input'>

            <div className='flex-inner-inputs  input-drawer-margin'>
              <Inputs
                label={translations[language]?.vechicleName}
                name='vehicleName'
                placeholder={translations[language]?.entervechicleName}
              // rules={[{ required: true, message: translations[language]?.pleaseEntervechicleName }]}
              />
            </div>
            <div className='flex-inner-inputs'>
              <Inputs
                label={translations[language]?.licensePlate}
                name='licensePlate'
                placeholder={translations[language]?.licensePlate}
                rules={[{ required: true, message: translations[language]?.enterLicensePlate }]}
              />
            </div>
          </div>
          <div className='flex-input'>
            <div className='flex-inner-inputs input-drawer-margin'>
              <Inputs
                label={translations[language]?.vehicleModel}
                name='vehicleModel'
                placeholder={translations[language]?.vehicleModel}
                rules={[{ required: true, message: translations[language]?.enterVehicleModel }]}
              />
            </div>
            <div className='flex-inner-inputs'>
              <Form.Item
                label={translations[language]?.operationStartDate}
                name='operationStartDate'
                rules={[{ required: true, message: translations[language]?.selectOperationStartDate }]}
              >
                <Datepicker
                  className='vehicle-datepicker'
                  format={dateFormate}
                  language={language}
                />
              </Form.Item>
            </div>
          </div>
          <div className='flex-input'>

            <div className='flex-inner-inputs input-drawer-margin'>

              <Form.Item
                label={translations[language]?.yearOfManufacture}
                name='yearOfManufacture'
                placeholder={translations[language]?.yearOfManufacture}
                rules={[{ required: true, message: translations[language]?.enterYearOfManufacture }]}
              >
                <DatePicker
                  className='vehicle-datepicker'
                  disabledDate={disabledDate}
                  picker="year"
                  placeholder={translations[language]?.selectYear}
                  style={{ minHeight: '44px' }}
                />
              </Form.Item>
            </div>

            <div className='flex-inner-inputs'>
              <Inputs
                label={translations[language]?.vehicleCategory}
                name='vehicleCategory'
                placeholder={translations[language]?.vehicleCategory}
                rules={[{ required: true, message: translations[language]?.enterVehicleCategory }]}
              />
            </div>

          </div>

          <div className='flex-input'>

            <div
              className={`flex-inner-inputs input-drawer-margin ${user?.role !== "superAdmin" ? "full-width" : ""
                }`}
            >
              <Inputs
                label={translations[language]?.registeringNumber}
                name='registeringNumber'
                placeholder={translations[language]?.registeringNumber}
                rules={[{
                  required: true,
                  message: translations[language]?.pleaseEnterRegisteringNumber,
                  pattern: /^[0-9]+$/,
                }]}
                type="text"
                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
              />
            </div>

            {user?.role === "superAdmin" && (
              <div className='flex-inner-inputs'>
                <CustomSelect
                  className='vehicle-org-dropdown'
                  label={translations[language]?.organizations}
                  placeholder={translations[language]?.organizationSelect}
                  name="organization"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  options={organizations?.map(org => ({
                    label: org.organization_name,
                    value: org.id,
                  }))}
                  rules={[{ required: true, message: translations[language]?.organizationSelect }]}
                />
              </div>
            )}


          </div>


          <Form.Item name="files" label={translations[language]?.logo}>
            <Upload
              listType="picture-card"
              maxCount={1}
              multiple={false}
              fileList={getFileList()}
              beforeUpload={handleUpload}
              onRemove={() => setLogoUrl(null)}
              accept={imageTypes}
            >
              <div>
                <UploadOutlined /> {translations[language]?.uploadLogo}
              </div>
            </Upload>
          </Form.Item>
          <Form.Item
            label={translations[language]?.techMaintenanceNotes}
            name='techMaintenanceNotes'
          >
            <Input.TextArea
              placeholder={translations[language]?.techMaintenanceNotes}
              autoSize={{ minRows: 5, maxRows: 6 }}
            />
          </Form.Item>
        </Form>
      </CustomModal>

      <CustomModal
        isVisible={viewModal}
        onClose={closeDetails}
        title={translations[language]?.vehicleDetails}
        actionText={translations[language]?.editVehicle}
        onAction={openEditModal}
        language={language}
      >
        <div>
          <h1 className='view-details-heading'>{translations[language]?.details}</h1>
          <div className='information-section'>

            <div className='inner-information-div'>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.vehicleName}</h3>
                  <p>{selectedRecord?.vehicle_name}</p>
                </div>
              </div>
            </div>

            <div className='inner-information-div'>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.licensePlate}</h3>
                  <p>{selectedRecord?.license_plate}</p>
                </div>

              </div>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.vehicleModel}</h3>
                  <p>{selectedRecord?.vehicle_model}</p>
                </div>
              </div>
            </div>

            <div className='inner-information-div'>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.yearOfManufacture}</h3>
                  <p>{selectedRecord?.year_of_manufacture}</p>
                </div>
              </div>
              <div className='info-childern-div'>
                <div className='inner-information-childern'>
                  <h3 className='info-heading'>{translations[language]?.vehicleCategory}</h3>
                  <p>{selectedRecord?.vehicle_category}</p>
                </div>
              </div>
            </div>

            <div className='inner-information-div'>

            </div>
            <div className='info-childern-div'>
              <div className='inner-information-childern'>
                <h3 className='info-heading'>{translations[language]?.operationStartDate}</h3>
                <p>{selectedRecord?.operation_start_date}</p>
              </div>
            </div>

            <div className='info-childern-div-textarea'>
              <div className='inner-information-childern'>
                <h3 className='info-heading'>{translations[language]?.techMaintenanceNotes}</h3>
                <p>{selectedRecord?.tech_maintenance_notes || translations[language]?.notProvided}</p>
              </div>
            </div>
            <div>
              <VehicleMap />
            </div>
          </div>
        </div>

      </CustomModal>

      <CustomModal
        isVisible={editModal}
        onClose={closeEditModal}
        actionText={translations[language]?.updateVehicle}
        title={translations[language]?.editVehicle}
        onAction={handleUpdateVehicle}
        loading={editDataLoading}
        language={language}
      >
        <Form form={editVehicles} layout='vertical'>

          <div className='flex-input'>

            <div className='flex-inner-inputs  input-drawer-margin'>
              <Inputs
                label={translations[language]?.vechicleName}
                name='vehicleName'
                placeholder={translations[language]?.entervechicleName}
                rules={[{ required: true, message: translations[language]?.pleaseEntervechicleName }]}
              />
            </div>
            <div className='flex-inner-inputs'>

              <Inputs
                label={translations[language]?.licensePlate}
                name='licensePlate'
                placeholder={translations[language]?.licensePlate}
                rules={[{ required: true, message: translations[language]?.enterLicensePlate }]}
              />
            </div>
          </div>
          <div className='flex-input'>
            <div className='flex-inner-inputs input-drawer-margin'>
              <Inputs
                label={translations[language]?.vehicleModel}
                name='vehicleModel'
                placeholder={translations[language]?.vehicleModel}
                rules={[{ required: true, message: translations[language]?.enterVehicleModel }]}
              />
            </div>
            <div className='flex-inner-inputs'>
              <Form.Item
                label={translations[language]?.operationStartDate}
                name='operationStartDate'
                rules={[{ required: true, message: translations[language]?.selectOperationStartDate }]}
              >
                <Datepicker
                  className='vehicle-datepicker'
                  format={dateFormate}
                  disabledDate={disabledDate}
                  language={language}
                />
              </Form.Item>
            </div>
          </div>
          <div className='flex-input'>
            <div className='flex-inner-inputs input-drawer-margin'>
              <Form.Item
                label={translations[language]?.yearOfManufacture}
                name='yearOfManufacture'
                placeholder={translations[language]?.yearOfManufacture}
                rules={[{ required: true, message: translations[language]?.enterYearOfManufacture }]}
              >
                <DatePicker
                  className='vehicle-datepicker'
                  disabledDate={disabledDate}
                  picker="year"
                  placeholder={translations[language]?.selectYear}
                  style={{ minHeight: '44px' }}
                />
              </Form.Item>
            </div>
            <div className='flex-inner-inputs'>
              <Inputs
                label={translations[language]?.vehicleCategory}
                name='vehicleCategory'
                placeholder={translations[language]?.vehicleCategory}
                rules={[{ required: true, message: translations[language]?.enterVehicleCategory }]}
              />
            </div>
          </div>

          <div className='flex-input'>

            <div
              className={`flex-inner-inputs input-drawer-margin ${user?.role !== "superAdmin" ? "full-width" : ""
                }`}
            >
              <Inputs
                label={translations[language]?.registeringNumber}
                name='registeringNumber'
                placeholder={translations[language]?.registeringNumber}
                rules={[{
                  required: true,
                  message: translations[language]?.pleaseEnterRegisteringNumber,
                  pattern: /^[0-9]+$/,
                }]}
                type="text"
                onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
              />
            </div>
            {user?.role === "superAdmin" && (
              <div className='flex-inner-inputs'>
                <CustomSelect
                  className='vehicle-org-dropdown'
                  label={translations[language]?.organizations}
                  placeholder={translations[language]?.organizationSelect}
                  name="organization"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  options={organizations?.map(org => ({
                    label: org.organization_name,
                    value: org.id,
                  }))}
                  rules={[{ required: true, message: translations[language]?.organizationSelect }]}
                  disabled={true}
                />
              </div>
            )}
          </div>

          <Form.Item name="files" label={translations[language]?.logo}>
            <Upload
              listType="picture-card"
              maxCount={1}
              fileList={getFileList()}
              beforeUpload={handleUpload}
              onRemove={() => setLogoUrl(null)}
              accept={imageTypes}
            >
              <div>
                <UploadOutlined /> {translations[language]?.uploadLogo}
              </div>
            </Upload>
          </Form.Item>

          <Form.Item
            label={translations[language]?.techMaintenanceNotes}
            name='techMaintenanceNotes'
          >
            <Input.TextArea
              label={translations[language]?.techMaintenanceNotes}
              name='techMaintenanceNotes'
              placeholder={translations[language]?.techMaintenanceNotes}
              component='textarea'
              className='custom-inputs'
              autoSize={{ minRows: 5, maxRows: 6 }}
            />
          </Form.Item>
        </Form>
      </CustomModal>

      <CustomModal
        isVisible={uploadModal}
        onClose={() => {
          setUploadModal(false)
          setSelectedOrgForUpload(null)
          setExcelFile(null)
          uploadForm.resetFields()
        }}
        title={translations[language]?.uploadVehicle}
        actionText={translations[language]?.uploadVehicle}
        onAction={handleExcelUpload}
        loading={uploadLoading}
        language={language}
      >
        <div className='vl-upload-hint'>
          <FaUpload />
          <span>{translations[language]?.uploadVehicleHint}</span>
        </div>
        <Form form={uploadForm} layout='vertical'>
          {user?.role === 'superAdmin' && (
            <Form.Item
              label={translations[language]?.organizations}
              name='organization'
              rules={[{ required: true, message: translations[language]?.organizationSelect }]}
            >
              <CustomSelect
                placeholder={translations[language]?.organizationSelect}
                value={selectedOrgForUpload}
                onChange={(val) => setSelectedOrgForUpload(val)}
                options={organizationFromRedux?.map((org) => ({
                  label: org.organization_name,
                  value: org.id,
                }))}
              />
            </Form.Item>
          )}

          <div className='ps-form-grid'>
            <Form.Item
              label={translations[language]?.operationStartDate}
              name='operationStartDate'
              rules={[{ required: true, message: translations[language]?.selectOperationStartDate }]}
            >
              <Datepicker
                className='vehicle-datepicker'
                format={dateFormate}
                language={language}
              />
            </Form.Item>

            <Form.Item
              label={translations[language]?.yearOfManufacture}
              name='yearOfManufacture'
              rules={[{ required: true, message: translations[language]?.enterYearOfManufacture }]}
            >
              <DatePicker
                className='vehicle-datepicker'
                picker='year'
                disabledDate={(current) => current && current > moment().endOf('day')}
                placeholder={translations[language]?.selectYear}
                style={{ minHeight: '44px', width: '100%' }}
              />
            </Form.Item>
          </div>

          <Form.Item label={translations[language]?.uploadExcelFile || 'Upload Excel File'} required>
            <Upload.Dragger
              className={`vl-upload-drag${excelFile ? ' has-file' : ''}`}
              accept=".xlsx, .xls"
              showUploadList={false}
              maxCount={1}
              beforeUpload={(file) => {
                if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
                  message.error('Please upload a valid Excel file (.xlsx or .xls)')
                  return Upload.LIST_IGNORE
                }
                setExcelFile(file)
                return false
              }}
            >
              <div className='vl-upload-drop'>
                <span className='vl-upload-icon'>{excelFile ? <FaCheck /> : <FaUpload />}</span>
                <span className='vl-upload-title'>
                  {excelFile ? translations[language]?.replaceExcelHint : translations[language]?.dropExcelHere}
                </span>
                <span className='vl-upload-sub'>{translations[language]?.excelOnly}</span>
              </div>
            </Upload.Dragger>
            {excelFile && (
              <div className='vl-file-chip'>
                <span className='vl-file-check'><FaCheck /></span>
                <span className='vl-file-ext'>{excelFile.name.split('.').pop().toUpperCase()}</span>
                <span className='vl-file-name' title={excelFile.name}>{excelFile.name}</span>
                <span className='vl-file-size'>{(excelFile.size / 1024).toFixed(0)} KB</span>
                <button type='button' className='vl-file-remove' onClick={() => setExcelFile(null)}>
                  {translations[language]?.removeFile}
                </button>
              </div>
            )}
          </Form.Item>
        </Form>
      </CustomModal>

      <DeleteModal
        title={translations[language]?.deleteVehicle}
        bodyText={
          <>
            {translations[language]?.areYouSureYouWantToDltThisVehicle}
          </>
        }
        isOpen={deleteModal}
        onCancel={handleCancel}
        onDelete={handleConfirmDelete}
        language={language}
      />
      <div className={`search-organization-main-div ${searchModal ? 'open' : ''}`}>
        <SearchOrganizations
          selectedOrganizations={organizationFilter}
          handleOrganizationChange={handleOrganizationChange}
          organizations={organizations}
          setSearchModal={setSearchModal}
          selectedFilter={organizationFilter}
          searchModal={searchModal}
          language={language}
          searchType={"vehicles"}
        />
      </div>
      <div className={`search-organization-main-div ${searchUserModal ? 'open' : ''}`}>
        <SearchUser
          selectedUsers={selectedUsers}
          handleUserChange={handleUserChange}
          users={users}
          setSearchUserModal={setSearchUserModal}
          searchUserModal={searchUserModal}
          language={language}
        />

        <GtfsUpload
          isVisible={gtfsModal}
          onClose={() => setGtfsModal(false)}
          language={language}
          user={user}
          organizations={organizationFromRedux}
        />
      </div>
    </div >

  )

}

export default Vehicles
